<template>
    <b-modal
        v-model="modal"
        v-if="internship"
        modal-class="apprentice-default-modal update-internship-modal"
        :id="`update-internship-modal-${internship.id}`"
        ref="update-internship-modal"
        size="md"
        :title="$t('group.internship.edit_internship', { name: internship.name })"
        :ok-title="$t('common.save')"
        @ok="updateSelectedInternship"
        cancel-variant="outline-primary"
        :cancel-title="$t('common.cancel')">
        <div class="edit-internship">
            <div
                class="errors"
                v-if="hasError">
                <b-alert
                    variant="danger"
                    show>
                    {{ $t('group.internship.feedback_field_is_a_mandatory_field') }}
                </b-alert>
            </div>

            <div class="swap-internship">
                <label for="internship-select">{{ $t('group.internship.choose_internship') }}</label>
                <b-form-select
                    class="apprentice-select"
                    id="internship-select"
                    v-model="selectedInternship"
                    :required="true"
                    :options="internships">
                </b-form-select>
            </div>

            <b-form-group class="feedback-group">
                <label for="internship-status-update-feedback-textarea">Feedback <span class="required"></span></label>
                <b-form-textarea
                    class="apprentice-textarea"
                    id="internship-status-update-feedback-textarea"
                    v-model="feedback"
                    rows="4"
                    :placeholder="$t('group.internship.give_your_feedback')">
                </b-form-textarea>
            </b-form-group>
        </div>
    </b-modal>
</template>

<script>
export default {
    name: 'design-2021-group-show-change-internship-modal-component',
    props: {
        internshipsIn: {
            type: Array,
            required: true,
        },
    },

    data() {
        return {
            modal: false,
            internship: {},
            selectedInternship: null,
            internships: [],
            initialId: null,
            feedback: null,
            hasError: false,
        };
    },

    methods: {
        show(internship) {
            this.modal = true;
            this.initialId = internship.id;
            this.internship = internship;
            this.selectedInternship = internship.id;
            this.internships = this.internshipsIn
                .filter((project) => project.placements > project.placements_filled || project.id === internship.id)
                .map((iship) => {
                    return {
                        value: iship.id,
                        text: iship.name,
                        disabled:
                            iship.id === internship.id && iship.placements_filled >= iship.placements ? true : false,
                    };
                });

            this.feedback = null;
        },

        updateSelectedInternship(bvModalEvent) {
            this.hasError = false;

            if (this.selectedInternship !== this.internship.id) {
                if (this.feedback === null || this.feedback === '') {
                    bvModalEvent.preventDefault();
                    this.hasError = true;
                    return;
                }

                this.$emit('updated-internship', {
                    initialInternshipId: this.initialId,
                    internshipId: this.selectedInternship,
                    projectId: this.internship.pivot.project_id,
                    feedback: this.feedback,
                });
            }
        },
    },
};
</script>

<style scoped lang="scss">
select {
    width: 100%;
}

.swap-internship {
    margin-bottom: $grid-gutter-width;
}
</style>
